import { LOCALE_ID, Injectable } from '@angular/core';
import localeId from '@angular/common/locales/id';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { registerLocaleData, TitleCasePipe, AsyncPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { AppDefaultComponent } from './app-default.component';
import { AuthModule } from 'projects/insight/src/app/routes/auth/auth.module';
import * as Hammer from 'hammerjs';
import { NotFoundComponent } from 'projects/insight/src/app/routes/frontend/not-found.component';
import { UnauthorizedComponent } from 'projects/insight/src/app/routes/frontend/unauthorized.component';
import { LogoutComponent } from './routes/auth/logout/logout.component';
import { UiModule } from '@insight/ui';
import { MAT_COLOR_FORMATS, NgxMatColorPickerModule, NGX_MAT_COLOR_FORMATS } from '@angular-material-components/color-picker';
import { provideEnvironmentNgxCurrency } from 'ngx-currency';
import { IServiceModule } from '@insight/services';

import { environment } from '../environments/environment';
import { MarkdownModule, MARKED_OPTIONS } from 'ngx-markdown';
import { MarkedOptions } from 'marked'; // <-- type-only import

registerLocaleData(localeId, 'id');

@Injectable()
export class PatchedGestureConfig extends HammerGestureConfig {
  overrides: any = {
    pinch: {
      direction: Hammer.DIRECTION_ALL,
      enable: true
    },
    pan: {
      direction: Hammer.DIRECTION_ALL,
      requireFailure: ['pinch'],
      threshold: 2
    },
    swipe: {
      direction: Hammer.DIRECTION_ALL,
      enable: true
    }
  };
}

export const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: ',',
  precision: 0,
  prefix: '',
  suffix: '',
  thousands: '.',
  nullable: true
};

@NgModule({
  declarations: [
    AppComponent,
    AppDefaultComponent,
    NotFoundComponent,
    UnauthorizedComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthModule,
    NgbModule,
    UiModule,
    IServiceModule.forRoot({ environment }),
    HammerModule,
    NgxMatColorPickerModule,
    MarkdownModule.forRoot({
      markedOptions: {
        provide: MARKED_OPTIONS,  // ✅ this is the DI token
        useValue: {
          gfm: true,
          breaks: false
        } satisfies MarkedOptions, // optional: helps with type checking
      },
    })
  ],
  providers: [
    // {
    // 	provide: ErrorHandler,
    // 	useFactory: errorHandlerFactory
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: LOCALE_ID, useValue: 'id'
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: PatchedGestureConfig
    },
    {
      provide: MAT_COLOR_FORMATS,
      useValue: NGX_MAT_COLOR_FORMATS
    },
    provideEnvironmentNgxCurrency(customCurrencyMaskConfig),
    JwtHelperService,
    TitleCasePipe,
    AsyncPipe,
    CurrencyPipe,
    DatePipe,
    LogoutComponent,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule { }
